import { EntityName } from 'record-it-time-common/EntityName';
import { User } from '../../../classes/entities/User/userTypes';
import { useEntityDeleteHandler } from './useEntityDeleteHandler';

export function useUserDeleteHandler(user: User): () => void {
  return useEntityDeleteHandler(EntityName.User, user, (u) => u.email);
}
